import {useState} from 'react';
import {Modal, Row, Col, Checkbox, Popover} from 'antd';
import {toFSDateTime} from "../../util/timeutils";
import {RoomMetricType, UnitType} from "../../api/Constants";
import * as dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat);

const parseTHC = (terms, lines) => {
    const parsedValues = [];

    // create a map for vertical columns of data
    for (let i=1; i<lines.length; i++) {
        const l = lines[i];
        if (l.length ===0) {
            continue;
        }
        const lterms = l.split(",");
        const ts = new Date(lterms[0]);

        for (let j=1; j<lterms.length; j++) {
            let type;
            let unit;
            let val = lterms[j];
            if (val.length === 0) {
                // exit fast when there's no data
                continue;
            }

            const valueLabel = terms[j].toLowerCase();
            if (valueLabel.includes("temp")) {
                type = RoomMetricType.Temperature
                if (terms[j].endsWith("F)")) {
                    unit = UnitType.Fahrenheit;
                } else {
                    unit = UnitType.Celsius;
                }
            } else if (valueLabel.includes("co2")) {
                type = RoomMetricType.CO2
                unit = UnitType.Percent
            } else if (valueLabel.includes("hum")) {
                type = RoomMetricType.Humidity
                unit = UnitType.Percent;
            }

            val = parseFloat(val);

            if ((!isNaN(ts.valueOf())) && (!isNaN(val))) {
                parsedValues.push({
                    value: val,
                    timestamp: ts,
                    unit,
                    sensor: terms[j],
                    metric: type
                })
            }
        }
    }
    return parsedValues;
}

const parseFeed = (terms, lines) => {
    const parsedValues = [];
    // create a map for vertical columns of data
    for (let i=1; i<lines.length; i++) {
        const l = lines[i];
        if (l.length ===0) {
            continue;
        }
        const lterms = l.split(",");
        const ts = new Date(lterms[0]);
        for (let j=1; j<lterms.length; j++) {
            const val = lterms[j].toLowerCase();
            if (val.includes("open")) {
                parsedValues.push({
                    value: 1,
                    timestamp: ts,
                    unit: UnitType.Each,
                    sensor: terms[j],
                    metric: RoomMetricType.Feed
                })
            } else if (val.includes("close")) {
                parsedValues.push({
                    value: 0,
                    timestamp: ts,
                    unit: UnitType.Each,
                    sensor: terms[j],
                    metric: RoomMetricType.Feed
                })
            }
        }
    }
    return parsedValues;
}

const parseGrodan = (lines) => {
    const parsedValues = [];

    console.log(`found Grodan sensor`);
    for (let i = 1; i < lines.length; i++) {
        const l = lines[i];
        if (l.length === 0) {
            continue;
        }
        const terms = l.split(",");
        const sanitizedTime = terms[0].replace(".", "");
        const djs = dayjs(sanitizedTime, 'MMM DD YYYY hh:mm a');
        const ts = djs.toDate();
        const sensor = "Grodan"; // terms[2];
        const val = parseFloat(terms[4])
        const unitString = terms[5];
        const measurement = terms[6].toLowerCase();
        let metric;
        let unit;
        // console.log(terms);

        if (measurement === "vpd") {
            metric = RoomMetricType.VPD;
            unit = UnitType.hPa;
        } else if (measurement === "relative humidity") {
            metric = RoomMetricType.Humidity;
            unit = UnitType.Percent;
        } else if (measurement.startsWith("co")) {
            metric = RoomMetricType.CO2;
            unit = UnitType.PPM;
        } else if (measurement === "internal temperature") {
            metric = RoomMetricType.Temperature;
            unit = unitString.endsWith("F") ? UnitType.Fahrenheit : UnitType.Celsius;
        } else if (measurement === "wc") {
            metric = RoomMetricType.WC;
            unit = UnitType.Percent;
        } else if (measurement === "rootzone temperature") {
            metric = RoomMetricType.RootZoneTemperature;
            unit = unitString.endsWith("F") ? UnitType.Fahrenheit : UnitType.Celsius;
        } else if (measurement === "ec") {
            metric = RoomMetricType.EC
            unit = UnitType.mScm;
        } else if (measurement === "wc") {
            console.log(`unknown metric ${measurement}`);
            unit = UnitType.Each;
        }

        if ((!isNaN(ts.valueOf())) && (!isNaN(val))) {
            parsedValues.push({
                timestamp: ts,
                value: val,
                unit,
                sensor,
                metric
            });
        }
    }

    return parsedValues;
}

export const CSVUploadModal = ({open, onUpload, onOk, onCancel, props}) => {
    const [values, setValues] = useState([]);
    const [isDelete, setIsDelete] = useState(false);
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        // Triggered when reading is complete
        reader.onload = (event) => {
            const text = event.target.result;
            const lines = text.split("\n");
            // console.log(`lines length ${lines.length}`);

            // detect the type
            const terms = lines[0].split(",");
            let parsedValues;
            // check the column label
            const columnLabel = terms[1].toLowerCase();

            // length 2 indicates basic CSV format
            if (columnLabel.includes("feedvalve")) {
                parsedValues = parseFeed(terms, lines);
            } else if (columnLabel.includes("sensor")) {
                parsedValues = parseGrodan(lines);
            } else {
                // THC sensor
                parsedValues = parseTHC(terms, lines);
            }

            setValues(parsedValues);

        };
        // Choose format: readAsText, readAsDataURL (for images), or readAsArrayBuffer
        reader.readAsText(file);
    };

    const onModalOk = () => {
        if (onOk) {
            onOk(values, isDelete)
        }
        setValues([]);
    }

    const onModalCancel = () => {
        if (onCancel) onCancel();
        setValues([]);
    }

    const onCheckDelete = (e) => {
        setIsDelete(e.target.checked);
    }

    // const modalStyle = {
    //     body: {height: '200px'}
    // }

    const rowStyle={
        margin: '5px'
    }

    const labelStyle = {
        marginRight: '5px'
    }


    return <Modal title={<b>Upload CSV</b>} open={open} onOk={onModalOk} onCancel={onModalCancel} okButtonProps={{disabled: values.length <= 0}}>
        <input type="file" onChange={handleFileChange} />
        {(values.length > 0) && <Row style={rowStyle}>
            <Col style={labelStyle}>
                <b>Values Detected:</b>
            </Col>
            <Col>
                {values.length}
            </Col>
        </Row>
        }
        {(values.length > 0) && <Row style={rowStyle}>
            <Col style={labelStyle}>
                <b>First Value:</b>
            </Col>
            <Col style={labelStyle}>
                {toFSDateTime(values[0].timestamp)}
            </Col>
            <Col>
                {values[0].value}
            </Col>
        </Row>
        }
        {(values.length > 0) && <Row style={rowStyle}>
            <Col style={labelStyle}>
                <b>Last Value:</b>
            </Col>
            <Col style={labelStyle}>
                {toFSDateTime(values[values.length-1].timestamp)}
            </Col>
            <Col>
                {values[values.length-1].value}
            </Col>
        </Row>
        }
        <Row style={rowStyle}>
        <Checkbox checked={isDelete} onChange={onCheckDelete}>
            <Popover content={'Check to delete data from this room'}>Delete</Popover>
        </Checkbox>
        </Row>
    </Modal>
}